/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import { IModelConnection } from "@itwin/core-frontend";
import { ScreenViewport, Viewport } from "@itwin/core-frontend";
import { OnFlashedIdChangedEventArgs } from "@itwin/core-frontend";
import { CursorInformation } from "@itwin/appui-react";
import { AbstractToolbarProps } from "@itwin/appui-abstract";

import { PopupToolbarManager, PopupToolbarProvider } from "./ToolbarPopup";
import { cView } from "./View";
import { cViewClip } from "./ViewClip";
import { cQuery } from "./Query";

export class cSelectionPopup {
  private static iModel: IModelConnection;
  private static sViewPort: ScreenViewport;
  private static toolbar: PopupToolbarProvider;

  public static initPopupToolbar = async(vp: ScreenViewport, imodel: IModelConnection) => {
    this.iModel = imodel;
    this.sViewPort = vp;

    this.toolbar = new cToolbarProvider();
    this.enablePopupToolbar();
  }

  public static enablePopupToolbar = () => {
    this.sViewPort.onFlashedIdChanged.addListener(this.onFlash);
  }

  public static disablePopupToolbar = () => {
    this.sViewPort.onFlashedIdChanged.removeListener(this.onFlash);
  }

  private static onFlash = async (vp: Viewport, ev: OnFlashedIdChangedEventArgs) => {
    const current = ev.current;
    const prev = ev.previous;
    const x = CursorInformation.cursorX;
    const y = CursorInformation.cursorY - 50;

    if (current) {
      const tag = await cQuery.getElementTag([current]);
      if (tag && !tag[0].includes(".jpg")) {
        PopupToolbarManager.showToolbar(this.toolbar, current, x, y);
      }
    } else {
      PopupToolbarManager.closeToolbar();
    }

    // console.log(`OnFlashedId: Current: ${current}, Previous: ${prev}`);
    // console.log(`OnFlashedId: X: ${x}, Y: ${y}`);
  };
}

export class cToolbarProvider implements PopupToolbarProvider {
  delayPopup: number = 2000;
  delayClose: number = 3000;

  public get toolbarProps(): AbstractToolbarProps {
    return {
      items: [
        {
          id: "zoom-element",
          itemPriority: 10,
          label: "Zoom",
          icon: "icon-zoom-in-2",
          execute: () => {},
          isDisabled: false,
        },
        {
          id: "clip-element",
          itemPriority: 30,
          label: "Clip",
          icon: "icon-crop",
          execute: () => {},
          isDisabled: false,
        },
        {
          id: "clip-box-element",
          itemPriority: 20,
          label: "Clipping Box",
          icon: "icon-section-element",
          execute: () => {},
          isDisabled: false,
        },
      ],
    };
  }

  public async itemExecuted(id: string, commandId: string) {
    console.log(`PopupToolbar: ${commandId} selected: ${id}`);

    switch (commandId) {
      case "zoom-element":
        cView.zoomToElement([id]);
        break;
      case "clip-element":
        cViewClip.clipToElement(id);
        break;
      case "clip-box-element":
        cViewClip.elementClippingTool(id);
        break;
    }
  }
}
